<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'ProductTypeList' }">Product Types</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
      ref="product_type" 
      :model="product_type"
      :rules="rules.product_type"
      :label-position="label_position">

      <el-form-item label="Name" prop="name">
            <el-input v-model="product_type.name"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
            <el-input v-model="product_type.description"></el-input>
        </el-form-item>
        <el-form-item label="Tax Class:" prop="tax_class_id">
            <el-select 
                v-model="product_type.tax_class_id" 
                placeholder="Select Here">
                <el-option
                v-for="item in tax_classes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
        </el-form-item> 

         <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number :min="0" v-model="product_type.sort_order"></el-input-number>
        </el-form-item>

       <el-form-item>
          <el-button type="primary" @click="updateProductType('product_type')">Update</el-button>
        </el-form-item>
    </el-form>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  export default {
    data: function() {
      return { 
        config: Config.config,
        page_alias: 'Edit Product Type',
        page_slug: 'edit-product-type',
        label_position: 'top',
        rules: {
          product_type: {
            name: [
                {required: true, message: 'Please Enter Product Name', trigger: 'blur'}
            ],
            description: [
                {required: true, message: 'Please Enter Product Description', trigger: 'blur'}
            ],
            sort_order: [
                {required: true, message: 'Please Select Sort Order', trigger: 'blur'}
            ],
            tax_class_id: [
                {required: true, message: 'Please Select Tax Class', trigger: 'blur'}
            ],
          }
        },

        product_type: {
          
        },

        tax_classes: {

        },
      };
    },

    mounted: function() {
      const me = this;
      me.getProductType();
      me.getTaxClasses();
    },

    methods: {
      getTaxClasses: function(goToPage) {
          console.log('get tax function');
          const me = this;
          // start the loader
          me.loading = true;
          me.$http.get(me.config.api + 'taxClasses').then(
          response => {
            console.log('Success Getting Data')  
            console.log(response.status);
            console.log(response.statusText);
            // get body data
            me.tax_classes = response.body.data;
            // end the loader
            me.loading = false;
            }, response => {
            console.log('Error Getting Data');
            console.log(response.status);
            console.log(response.statusText);
            me.$notify({
                title: 'Error',
                message: response.statusText,
                type: 'error'
            });
            // end the loader
            me.loading = false;
            });
        },

      getProductType: function() {
        console.log('Get Product Type Function');
        const me = this;
        me.$http.get(me.config.api + 'product-type/{id}?basic=1', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);
          me.product_type = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      updateProductType: function(formName) {
        console.log('Update Product Type Function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            me.$http.put(me.config.api + 'product-type/{id}', me.product_type, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Success Putting Data')  
              console.log(response.status);
              console.log(response.statusText);

              me.getProductType();
              
              me.$notify({
                title: 'Success',
                message: 'The Product Type Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Error Putting Data');
              console.log(response.status);
              console.log(response.statusText);
              console.log(response.bodyText);
          });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/product-types/ProductTypeEdit.vue